// extracted by mini-css-extract-plugin
module.exports = {"mCard":"sh","image":"th","imageNoBackground":"uh"};